export interface BudgetDrawerContext {
  budgetId: number;
  opportunityId: number;
}

const budgetMaestroNames = new Set(['Presupuestos', 'Cotizaciones']);

function toPositiveNumber(value: unknown): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function resolveBudgetDrawerContext(
  maestroName: string,
  item: any,
  routeParams: Record<string, unknown> = {},
  queryParams: Record<string, unknown> = {},
): BudgetDrawerContext | null {
  if (!budgetMaestroNames.has(maestroName)) {
    return null;
  }

  const itemBudgetId = toPositiveNumber(item?.id);
  const itemOpportunityId = toPositiveNumber(item?.leadId);

  if (itemBudgetId && itemOpportunityId) {
    return {
      budgetId: itemBudgetId,
      opportunityId: itemOpportunityId,
    };
  }

  const routedBudgetId = toPositiveNumber(
    routeParams['budgetId'] ?? queryParams['budget'],
  );
  const routedOpportunityId = toPositiveNumber(
    routeParams['opportunityId'] ?? queryParams['opportunity'] ?? item?.id,
  );

  if (!routedBudgetId || !routedOpportunityId) {
    return null;
  }

  return {
    budgetId: routedBudgetId,
    opportunityId: routedOpportunityId,
  };
}
